import Avatar from 'assets/image/avatar.png';
import BG1 from 'assets/image/bg-1.jpg';
import BG2 from 'assets/image/bg-2.jpg';
import BG3 from 'assets/image/bg-3.jpg';
import BG4 from 'assets/image/bg-4.jpg';
import BG5 from 'assets/image/bg-5.jpg';
import BG6 from 'assets/image/bg-6.jpg';
import BG7 from 'assets/image/bg-7.jpg';
import BG8 from 'assets/image/bg-8.jpg';
import BG9 from 'assets/image/bg-9.jpg';

import CARD1 from 'assets/image/card-1.png';
import CARD2 from 'assets/image/card-2.png';
import CARD3 from 'assets/image/card-3.png';

import MARK from 'assets/image/mark.jpg';
import SEAL_YELLOW from 'assets/image/seal-yellow.png';

import FRONTEND from 'assets/image/frontend.png';
import BACKEND from 'assets/image/backend.png';
import AI from 'assets/image/AI.png';
import SUB_AI from 'assets/image/sub_ai.png';

import DARK from 'assets/image/dark.jpg';
import BRIGHT from 'assets/image/bright.jpg';

import ASUNA from 'assets/image/asuna.jpg';
import CERASHEALTH from 'assets/image/cerashealth.png';
import SPORTSBLOG from 'assets/image/sportsblog.png';
import PICKADE from 'assets/image/pickade.png';
import CBET from 'assets/image/cbet.png';
import RAFFLE from 'assets/image/raffle.png';
import MAPBOX from 'assets/image/mapbox.png';
import BLOXMOON from 'assets/image/bloxmoon.png';
import AMINOREWARDS from 'assets/image/aminorewards.png';
import ARMORY from 'assets/image/armory.png';
import BANNER from 'assets/image/banner.png';
import JOBWIZARD from 'assets/image/jobwizard.png';
import MENAJI from 'assets/image/menaji.png';
import PAROSOL from 'assets/image/parosol.png';
import MULTIAGENT from 'assets/image/multiagent.png';
import OLLAMA from 'assets/image/ollama.png';
import ZEBRACAT from 'assets/image/zebracat.png';
import APPOINTY from 'assets/image/appointy.png';
import PIXORA from 'assets/image/pixora.png';
import BANKING from 'assets/image/banking.png';

const constantImages = {
    Avatar,
    BG1,
    BG2,
    BG3,
    BG4,
    BG5,
    BG6,
    BG7,
    BG8,
    BG9,
    FRONTEND,
    BACKEND,
    AI,
    SUB_AI,
    MARK,
    SEAL_YELLOW,
    DARK,
    BRIGHT,
    CARD1,
    CARD2,
    CARD3,
    ASUNA,
    CERASHEALTH,
    SPORTSBLOG,
    PICKADE,
    CBET,
    RAFFLE,
    MAPBOX,
    BLOXMOON,
    AMINOREWARDS,
    ARMORY,
    BANNER,
    JOBWIZARD,
    MENAJI,
    PAROSOL,
    MULTIAGENT,
    OLLAMA,
    ZEBRACAT,
    APPOINTY,
    PIXORA,
    BANKING
}

export default constantImages;